'use client';
import React, { useState } from 'react';
import SectionImage from '@/components/(landing)/landing/SectionImage';
import Image from 'next/image';
import CloseLineIcon from 'remixicon-react/CloseLineIcon';
import Cta from '@/components/(landing)/landing/Cta';
import { safeHtmlLinks } from '@/utils/links/safeHref';

interface CertificatesProps {
    data?: { certificates: { sourceUrl: string; title: string }[]; content: string };
}

const Certificates = ({ data }: CertificatesProps) => {
    const [modalImage, setModalImage] = useState<string | null>(null);

    return (
        <section className='bg-white pb-20'>
            <SectionImage
                key='custom-section-outside'
                className='lg:col-span-4 col-span-5 row-span-2'
                imageUrl='/nokhbegan/12-certificate.webp'
            />

            <div className='max-w-5xl mx-auto max-lg:px-5 py-5 flex items-center justify-center gap-5 flex-wrap'>
                {data?.certificates?.map((student, index) => (
                    <Image
                        key={`image-${index}`}
                        src={student?.sourceUrl || ''}
                        className='object-cover w-1/2 lg:w-36 h-auto cursor-pointer'
                        width={1800}
                        height={1800}
                        alt={student?.title}
                        onClick={() => setModalImage(student.sourceUrl)}
                    />
                ))}
            </div>

            <article
                className='max-w-4xl max-lg:px-3 mx-auto text-center leading-7 text-sm opacity-70'
                dangerouslySetInnerHTML={{ __html: safeHtmlLinks(data?.content || '') }}
            />
            <Cta />
            {modalImage && (
                <div
                    className='fixed inset-0 bg-black bg-opacity-80 backdrop-blur-md flex items-center justify-center z-50'
                    onClick={() => setModalImage(null)}
                >
                    <div className='relative max-lg:w-full max-w-full max-h-full lg:p-4 flex justify-center items-center'>
                        <Image
                            src={modalImage}
                            alt='Full Screen'
                            width={1200}
                            height={1200}
                            className='lg:w-auto w-11/12 h-auto max-w-screen max-h-screen rounded-lg'
                            onClick={(e) => e.stopPropagation()} // prevent modal close on image click
                        />
                        <button
                            onClick={() => setModalImage(null)}
                            className='absolute -top-12 right-5 text-black aspect-square bg-landing-gold rounded-full p-2 text-sm hover:brightness-110'
                        >
                            <CloseLineIcon />
                        </button>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Certificates;
